module.exports = __webpack_public_path__ + "img/IgnacyLukasiewicz.cddbb5a1.jpg";